var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 0.4,
    transform: "translate(7371 1951)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7371 -1951)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82 -45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 5,
    transform: "translate(7289 1996)",
    fill: "#adaeb9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 5,
    transform: "translate(7289 2001)",
    fill: "#9497a8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 5,
    transform: "translate(7289 2005)",
    fill: "#626467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.573-5.1v-.156a4.8,4.8,0,0,1,.144-1.278,1.907,1.907,0,0,1,.41-.77,3.157,3.157,0,0,1,.65-.531,4.32,4.32,0,0,0,.508-.38,1.631,1.631,0,0,0,.357-.437,1.094,1.094,0,0,0,.133-.538,1.012,1.012,0,0,0-.151-.554,1.01,1.01,0,0,0-.405-.366,1.228,1.228,0,0,0-.561-.128,1.261,1.261,0,0,0-.563.131,1.1,1.1,0,0,0-.435.385,1.192,1.192,0,0,0-.183.63H.608a2.709,2.709,0,0,1,.44-1.514,2.54,2.54,0,0,1,1.1-.893,3.8,3.8,0,0,1,1.516-.3,4.066,4.066,0,0,1,1.612.3,2.515,2.515,0,0,1,1.1.868,2.324,2.324,0,0,1,.4,1.37,2.409,2.409,0,0,1-.176.95,2.319,2.319,0,0,1-.492.733A3.747,3.747,0,0,1,5.363-7a2.963,2.963,0,0,0-.593.449,1.484,1.484,0,0,0-.344.541,2.285,2.285,0,0,0-.117.756V-5.1ZM3.48-2.167A1.064,1.064,0,0,1,2.7-2.49a1.043,1.043,0,0,1-.318-.776,1.03,1.03,0,0,1,.318-.77,1.068,1.068,0,0,1,.781-.321,1.064,1.064,0,0,1,.765.321,1.051,1.051,0,0,1,.334.77,1.065,1.065,0,0,1-.158.552,1.177,1.177,0,0,1-.4.4A1.029,1.029,0,0,1,3.48-2.167Z",
    transform: "translate(7295.392 2009.795)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownFlag);
export default __webpack_public_path__ + "static/media/unknown-flag.3bd37fd4dfff518acbd4e12e3adeea39.svg";
export { ForwardRef as ReactComponent };